import { memo } from 'react';
import styles from './SupportQuick.module.css';
import { ReactComponent as SupportIcon } from '../../assets/supportIcon.svg';

interface SupportQuickProps {
  bottom?: number | string;
}

const SupportQuick = ({
  bottom = 'calc(32px + env(safe-area-inset-bottom, 0px))',
}: SupportQuickProps) => {
  const tg = window.Telegram?.WebApp;
  const handleSupportClick = () => {
    if (tg?.openTelegramLink) {
      tg.openTelegramLink('https://t.me/menpoint1');
      return;
    }
    window.open('https://t.me/menpoint1', '_blank', 'noopener,noreferrer');
  };
  return (
    <button
      className={styles.wrapper}
      type="button"
      style={{ bottom }}
      onClick={handleSupportClick}
    >
      <SupportIcon className={styles.icon} />
    </button>
  );
};

export default memo(SupportQuick);
